import React from 'react';
import {Alert, Button, Card, Col, Form, Icon, Input, InputNumber, message, Modal, Popover, Row} from 'antd';
import {fetchEvt} from "../../redux/actions/evt";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import Iconfont from "../../components/Iconfont/Iconfont";
import {getFeeRate} from "../../services/global";
import {updateTicketingDiscount} from "../../services/ticket";
import Decimal from "decimal.js/decimal";
import NumberFormat from 'react-number-format';
import lodash from "lodash"
import MoneyInput from "../../components/MoneyInput";


const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return {cmEnums};
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewTicketingFormDiscount extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formLoading: false,
            memberNumPeo:500,
            cashWithdrawRate: null,
        }
    }

    componentDidMount() {
        this.mounted = true;
        getFeeRate().then(res => {
            if (res.code == 200) {
                this.setState({
                    cashWithdrawRate: res.data["CASH_WITHDRAW_RATE"]
                })
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })

    }

    componentWillUnmount() {
        this.mounted = false;
    }

    resetFormFields = () => {
        this.props.form.resetFields();
    }


    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.changeFormLoading(true);
                const that = this;

                // //去除_开头的属性(为了动态字段添加的)
                // var _values = {...values};
                // Object.keys(_values).forEach((key) => {
                //     if (key != "__self__" && key.startsWith("_")) {
                //         delete _values[key]
                //     }
                // })
                delete values['___self__'];
                if (JSON.stringify(values) === "{}") {
                    values.__self__ = [];
                }
                updateTicketingDiscount(Object.assign({eventId: this.props.evt.header.id,ticketingId:this.props.ticket.id}, values)).then(res => {
                    if (res.code == 200) {
                        message.info("更新成功!");
                        that.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    that.changeFormLoading(false)
                })
            } else {
            }
        });
    }

    changeFormLoading = (loading) => {
        if (this.mounted) {
            this.setState({
                formLoading: loading
            })
        }
    }

    addField = (fieldName, value = {}) => {
        const {form} = this.props;
        var fieldsValue = form.getFieldsValue();
        var _fieldVal = lodash.get(fieldsValue, `_${fieldName}`);
        _fieldVal.push(value);

        lodash.set(fieldsValue, `_${fieldName}`, _fieldVal);


        form.setFieldsValue(fieldsValue);
        this.setState({
            needReloadUniqueSelect: true,
        })
    }


    removeField = (fieldName, index) => {
        const {form} = this.props;
        var fieldsValue = form.getFieldsValue();
        let fieldVal = lodash.get(fieldsValue, fieldName);
        let _fieldVal = lodash.get(fieldsValue, `_${fieldName}`);
        fieldVal.splice(index, 1);
        _fieldVal.splice(index, 1);

        lodash.set(fieldsValue, `_${fieldName}`, _fieldVal);
        lodash.set(fieldsValue, fieldName, fieldVal);

        form.setFieldsValue(fieldsValue);

        this.setState({
            needReloadUniqueSelect: true,
        })
    }

    handleCancel = () => {
        this.changeFormLoading(false)
        // this.props.editableChange(this.props.editableStatePropName, false)
        this.props.show(false);
    }

    render() {
        const {evt,ticket} = this.props;

        const {getFieldDecorator, getFieldValue, getFieldError} = this.props.form;
        getFieldDecorator('___self__', {initialValue:ticket && ticket.discountList ?  ticket.discountList.map(t => t) : []});
        const ticketings = getFieldValue('___self__') ? getFieldValue('___self__') : [];


        const ticketComp =
            <Row gutter={18} className="form-item-ticket-comp">
                {ticketings.map((c, index) => {
                    return (
                        <Col span={12} key={`ticketings${index}`}>
                            <Card bodyStyle={{padding: "12px 12px 12px 0"}}>
                                <div className="form-item-ticket-contain">
                                    <div className="form-item-ticket-micon-contain">
                                        <Iconfont libname="ckicon" type="juan"/>
                                    </div>
                                    <div className="form-item-ticket-content-contain">
                                        <div style={{display: "none"}}>
                                            {getFieldDecorator(`__self__[${index}].discountType`, {
                                                initialValue: 'COUNT_REDUCE',
                                                rules: [{required: false}],
                                            })(
                                                <Input/>
                                            )}
                                        </div>
                                        <div style={{display: "none"}}>
                                            {getFieldDecorator(`__self__[${index}].id`, {
                                                initialValue: c.id,
                                                rules: [{required: false}],
                                            })(
                                                <Input/>
                                            )}
                                        </div>
                                        <div className='form-item-ticket-discount-title'>购买数量：</div>
                                        <Form.Item hasFeedback help="">
                                            <Input.Group compact>
                                                {getFieldDecorator(`__self__[${index}].count`, {
                                                    initialValue: c.count,
                                                    rules: [{type: "number", required: true}],
                                                })(
                                                    <InputNumber
                                                        min={0}
                                                        //max={this.state.memberNumPeo}
                                                        max={30000}
                                                        step={10}
                                                        precision={0}
                                                        placeholder="购买数量"
                                                        formatter={value => {
                                                            return `${value}张`;
                                                        }}
                                                        parser={value => {
                                                            return value.replace('张', '')
                                                        }}
                                                    />
                                                )}
                                            </Input.Group>
                                        </Form.Item>



                                    </div>
                                    <div className='form-item-ticket-money-discount'>
                                        <div className='form-item-ticket-discount-title'>总计金额：</div>
                                        <Form.Item hasFeedback help="">
                                            {getFieldDecorator(`__self__[${index}].amount`, {
                                                initialValue: c.amount,
                                                rules: [{required: true}],
                                            })(
                                                <MoneyInput
                                                    prefix={<Iconfont style={{fontSize: 18}} libname="ckicon" type="Money"/>}
                                                    placeholder="总计金额"
                                                />
                                            )}
                                        </Form.Item>
                                    </div>
                                    <a href="#" className="card-ck-contain-remove" onClick={() => this.removeField("__self__", index)}>
                                        <div><Icon type="delete"/>删除</div>
                                    </a>
                                </div>


                            </Card>
                        </Col>
                    )
                })}
                <Col span={3}>
                    <Card bodyStyle={{padding: "12px"}} style={{border: "none"}}>
                        <a className="card-ck-contain-add" onClick={() => this.addField("__self__", {count: 0, amount: 0})}> <Icon type="plus"/> </a>
                    </Card>
                </Col>
            </Row>

        return (
            <Form>

                <Modal
                    visible={this.props.editable}
                    title={<div>设置优惠票价，详见：<a href="https://www.kancloud.cn/seven_qdj/qdj_help_201808/737197" target='_Blank'>批发优惠 </a>和 <a href="https://www.kancloud.cn/seven_qdj/qdj_detail01/1822294" target='_Blank'>直减优惠码</a></div>}
                    width="880px"
                    afterClose={() => this.resetFormFields()}
                    maskClosable={false}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>
                            放弃
                        </Button>,
                        <Button key="submit" type="primary" loading={this.state.formLoading} onClick={this.save}>
                            保存
                        </Button>,
                    ]}
                >
                    {ticketComp}
                </Modal>
            </Form>
        )
    }
}


EvtViewTicketingFormDiscount.contextTypes = {}

EvtViewTicketingFormDiscount.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "ticketEditable",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewTicketingFormDiscount.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewTicketingFormDiscount));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewTicketingFormDiscount.jsx